import request from '@/utils/request';

/**
 * 获取所有标签 - 匹配TagController接口
 */
export function getAllTags() {
  return request({
    url: '/tags',
    method: 'get'
  });
}

/**
 * 创建标签 - 匹配TagController的POST /tags接口
 */
export function createTag(content) {
  return request({
    url: '/tags',
    method: 'post',
    data: { content }
  });
}

/**
 * 获取标签详情 - 匹配TagController的GET /tags/{id}接口
 */
export function getTagDetail(id) {
  return request({
    url: `/tags/${id}`,
    method: 'get'
  });
}

/**
 * 更新标签 - 匹配TagController的PUT /tags/{id}接口
 */
export function updateTag(id, content) {
  return request({
    url: `/tags/${id}`,
    method: 'put',
    data: { content }
  });
}

/**
 * 删除标签 - 匹配TagController的DELETE /tags/{id}接口
 */
export function deleteTag(id) {
  return request({
    url: `/tags/${id}`,
    method: 'delete'
  });
}

/**
 * 搜索标签 - 匹配TagController的GET /tags/search接口
 */
export function searchTags(keyword) {
  return request({
    url: '/tags/search',
    method: 'get',
    params: { keyword }
  });
}

/**
 * 获取标签使用统计 - 匹配TagController的GET /tags/count接口
 */
export function getTagUsageCount() {
  return request({
    url: '/tags/count',
    method: 'get'
  });
}

/**
 * 更新角色标签关联
 */
 export function updateRoleTags(roleId, tagIds) {
  return request({
    url: `/roles/${roleId}/tags`,
    method: 'put',
    data: { tagIds }
  });
}